import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../Layout'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'layout',
		component: Layout,
		redirect: 'homePage',
		children: [
			{
				path: 'homePage',
				name: 'homePage',
				component: () => import('../views/homePage'),
			},
			{
				path: 'product-introduction',
				name: 'product-introduction',
				component: () => import('../views/productIntroduction'),
				children: [
					{
						path: 'customBus',
						name: 'customBus',
						component: () => import('../views/customBus'),
					},
					{
						path: 'busChange',
						name: 'busChange',
						component: () => import('../views/busChange'),
					},
					{
						path: 'charterService',
						name: 'charterService',
						component: () => import('../views/charterService'),
					},
					{
						path: 'advertisingMerchants',
						name: 'advertisingMerchants',
						component: () => import('../views/advertisingMerchants'),
					},
				],
			},
			{
				path: 'about-us',
				name: 'about-us',
				component: () => import('../views/aboutUs'),
			},
		],
	},
]

const router = new VueRouter({
	routes,
	scrollBehavior: (to, from) => {
		if (to.name === 'about-us') {
			return { y: 0 }
		}
	},
})

export default router
